module.exports = __webpack_public_path__ + "img/Youtubeicon.0f52b014.svg";